import { RETURN_VALUE_ERROR_CODES, TRADE_ERROR_CODES } from '../constants';
import type { EthersError, GasLimitError, NestedEthersError, ReturnValue } from '../types';

export function getEthersGasLimitError(gasLimitError: GasLimitError): ReturnValue {
	const gasLimitErrorDetails = gasLimitError.message;
	console.log({ gasLimitErrorDetails, gasLimitError });

	if (gasLimitError && gasLimitErrorDetails) {
		// synthetix error when a order exists on the market
		if (
			gasLimitErrorDetails.reason &&
			gasLimitErrorDetails.reason.includes('execution reverted: previous order exists')
		) {
			return {
				title: TRADE_ERROR_CODES.PENDING_ORDER_EXISTS,
				description:
					'Previous order exists, wait for the order to execute or try cancelling any expired  orders'
			};
		}

		// synthetix error when order exists on the market and hasn't executed, happens when you try withdrawing margin
		// on an order that has not been executed yet
		if (
			gasLimitErrorDetails.reason &&
			gasLimitErrorDetails.reason.includes('execution reverted: Pending order exists')
		) {
			return {
				title: TRADE_ERROR_CODES.PENDING_ORDER_EXISTS,
				description: 'Previous order exists, try cancelling any expired orders'
			};
		}

		// Polynomial error, when limit price placed is invalid
		if (
			gasLimitErrorDetails.reason &&
			gasLimitErrorDetails.reason.includes('execution reverted: invalid-limit-price')
		) {
			return {
				title: TRADE_ERROR_CODES.INVALID_LIMIT_PRICE,
				description:
					'Check if limit price is above trigger price (when trigger price is above current price) and vice versa'
			};
		}

		// every other execution reverted error, any errors that need instructions can be handled seperately
		if (
			gasLimitErrorDetails.reason &&
			gasLimitErrorDetails.reason.includes('execution reverted: ')
		) {
			return {
				title: RETURN_VALUE_ERROR_CODES.GAS_LIMIT_ESTIMATION_ERROR,
				description: gasLimitErrorDetails.reason.slice('execution reverted: '.length)
			};
		}
	}
	return {
		title: RETURN_VALUE_ERROR_CODES.FAILED_TO_PARSE_ERROR,

		description: JSON.stringify(gasLimitError, Object.getOwnPropertyNames(gasLimitError))
	};
}
